<template>
<div class="chapter">
<div class="inner_page">
<h1 class="booktitle" id="pgepubid00000">A Witch of the Hills</h1>
<h2 class="sigil_not_in_toc">Vol 1 and 2 Complete</h2>
<h2 class="h1 sigil_not_in_toc">FLORENCE WARDEN</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?9f3d6ed0